import { render, staticRenderFns } from "./AAuditFooter.vue?vue&type=template&id=547927cb&scoped=true&"
import script from "./AAuditFooter.vue?vue&type=script&lang=ts&"
export * from "./AAuditFooter.vue?vue&type=script&lang=ts&"
import style0 from "./AAuditFooter.vue?vue&type=style&index=0&id=547927cb&lang=scss&scoped=true&"
import style1 from "./AAuditFooter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547927cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VFooter,VIcon,VRow,VSnackbar})
